








import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    CreateSteps: () =>
      import("@/components/onboarding/createaccount/CreateSteps.vue")
  }
})
export default class CreateAccount extends Vue {
  activeStep: number = 1;
  progress_by = 0;
  beforeMount() {
    if (
      ["facebook", "google", "linkedin", "twitter"].some(
        network => this.$store.state.user[`${network}_id`]
      )
    ) {
      this.activeStep = 2;
    }
  }
}
